<template>
    <div id="login" @keyup.enter="submit()" >

        <div v-if="$device.isDesktop">Desktop</div>

        <div class="login-intro" v-if="$root.app.platform == 'desktop'">
            Inloggen bij My Dubline            
        </div>

        <div class="error" v-if="error" v-html="error"></div>
        
        <div class="form-group" v-bind:class="{ 'form-group--error': $v.email.$error }">
            <label class="form__label">E-mail</label>
            <input class="form__input" v-model="email" type="email" @input="$v.email.$touch()">
        </div>
        <span class="form-group__message" v-if="!$v.email.email">Ongeldige e-mail</span>
        <span class="form-group__message" v-if="!$v.email.required">Veld is verplicht</span>
        <span class="form-group__message" v-if="!$v.email.minLength">E-mail moet minimaal {{$v.email.$params.minLength.min}} karakters bevatten.</span>

        <div class="form-group" v-bind:class="{ 'form-group--error': $v.password.$error }">
            <label class="form__label">Wachtwoord</label>
            <input class="form__input" type="password" v-model="password" @input="$v.password.$touch()">
        </div>
        <span class="form-group__message" v-if="!$v.password.required">Veld is verplicht</span>
        <span class="form-group__message" v-if="!$v.password.minLength">Wachtwoord moet minimaal {{$v.password.$params.minLength.min}} karakters bevatten.</span>

        <div class="form-group">
            <input class="button dub-button dub-button-space" type="submit" value="Login" @click="submit()"/>
        </div>
        
        <router-link to="/forgot-password">
            Wachtwoord vergeten?
        </router-link>
    </div>
</template>

<script>

    
    import { required, minLength, email } from 'vuelidate/lib/validators'

    

    export default {
    name: 'login',
        data () {
            return {
                email: '',
                password: '',
                error: false
            }
        },

        validations: {
            email: {
                required,
                minLength: minLength(4),
                email
            },
            password: {
                required,
                minLength: minLength(5)
            }
        },
        
        mounted(){
            
            //Hide loading screen
            var root = this.$root;
            root.loading = false;
            
            // Assuming $root.app.platform holds a valid truthy value
        
            if (this.$device.isDesktop == true) {
                // Redirect to the external website
                window.location.href = 'https://account.dubline.nl';
            }
        },
        
        methods:{
            
            submit(){
                
                var email = this.email;
                var password = this.password;
                var authService = this.$auth;
                var router = this.$router;
                var root = this.$root;
                var _this = this;

                root.loading = true;

                this.$api.post('/auth/token', {
                    email: email,
                    password: password
                })
                .then(response => {

                    authService.setTokens(response.data);
                    authService.authenticate(function(loggedIn){

                        if(loggedIn){

                            //Load the config file
                            _this.$api.get('/app/config')
                            .then(response => {
                                
                                var data = response.data;
                                
                                root.app = data.app;
                                root.user = data.user;
                                
                                //Register platform to UI
                                var platform = root.app.platform;
                                _this.$ui.setPlatform(platform);
                                
                                router.replace({path: '/app'});
                            })
                            .catch(e => {
                                
                                _this.$root.ui.showDialog(
                                    'Fout',
                                    'Unable to load config.',
                                    true
                                );
                            })

                            root.showMenuButton = true;
                        }

                        _this.email = '';
                    });
                })
                .catch(e => {

                    setTimeout(function(){

                        root.loading = false;

                    }, 500);

                    //var formErrors = JSON.parse(e.response.data.message);


                    let errors = '';
                    let keys = Object.keys(e.response.data.message);
                        keys.forEach( function(key) {
                        let value = e.response.data.message[key];
                        console.log(value);
                        errors = errors+(errors.length !==0 ? '' : '')+value;
                    })
                    this.error = errors;

                    //this.error = formErrors;
                    
                })

                _this.password = '';
            }
        }
        

    }
</script>


// WEBPACK FOOTER //
// src/components/auth/Login.vue